<template>
    <div class="field-selector">
        <!-- Primitive Fields -->
        <div class="field-group primitive-fields">
            <div class="group-title">Primitive Fields</div>
            <div class="group-content">
                <div class="field-item" @click="selectField('text')" v-tippy="{ content: 'Kısa metin girişi için kullanılır. İsim, başlık gibi bilgiler için uygundur.' }">
                    <i class="material-icons">text_fields</i>
                    <span>{{ $t("tables.text") }}</span>
                </div>
                <div class="field-item" @click="selectField('long-text')" v-tippy="{ content: 'Uzun metinler, açıklamalar ve notlar için kullanılır. Birden fazla paragraf girebilirsiniz.' }">
                    <i class="material-icons">subject</i>
                    <span>{{ $t("tables.longText") }}</span>
                </div>
                <div class="field-item" @click="selectField('number')" v-tippy="{ content: 'Sayısal değerler için kullanılır. Filtreleme ve hesaplamalarda kullanılabilir.' }">
                    <i class="material-icons">looks_one</i>
                    <span>{{ $t("tables.number") }}</span>
                </div>
                <div class="field-item" @click="selectField('currency')" v-tippy="{ content: 'Para birimi değerleri için kullanılır. Otomatik olarak para birimi formatında gösterilir.' }">
                    <i class="material-icons">attach_money</i>
                    <span>{{ $t("tables.currency") }}</span>
                </div>
                <div class="field-item" @click="selectField('datetime')" v-tippy="{ content: 'Tarih ve saat bilgilerini saklamak için kullanılır. Takvim üzerinden seçim yapabilirsiniz.' }">
                    <i class="material-icons">event</i>
                    <span>{{ $t("tables.datetime") }}</span>
                </div>
                <div class="field-item" @click="selectField('dropdown')" v-tippy="{ content: 'Önceden tanımlanmış seçeneklerden birini seçmek için kullanılır. Kategori veya durum bilgisi için uygundur.' }">
                    <i class="material-icons">arrow_drop_down</i>
                    <span>{{ $t("tables.dropdown") }}</span>
                </div>
                <div class="field-item" @click="selectField('checkbox')" v-tippy="{ content: 'Evet/Hayır tipinde bilgi saklamak için kullanılır. İşaretleme kutusunu işaretleyip kaldırabilirsiniz.' }">
                    <i class="material-icons">check_box</i>
                    <span>{{ $t("tables.checkbox") }}</span>
                </div>
            </div>
        </div>

        <!-- Validator Fields -->
        <div class="field-group validator-fields">
            <div class="group-title">Validator Fields</div>
            <div class="group-content">
                <div class="field-item" @click="selectField('url')" v-tippy="{ content: 'Web adresleri için kullanılır. Otomatik doğrulama ile geçerli URL\'leri kontrol eder.' }">
                    <i class="material-icons">link</i>
                    <span>URL</span>
                </div>
                <div class="field-item" @click="selectField('email')" v-tippy="{ content: 'E-posta adresleri için kullanılır. Otomatik doğrulama ile geçerli e-posta formatını kontrol eder.' }">
                    <i class="material-icons">email</i>
                    <span>{{ $t("tables.email") }}</span>
                </div>
                <div class="field-item" @click="selectField('phone')" v-tippy="{ content: 'Telefon numaraları için kullanılır. Formatlama ve doğrulama özelliği ile geçerli telefon numaralarını kontrol eder.' }">
                    <i class="material-icons">phone</i>
                    <span>{{ $t("tables.phone") }}</span>
                </div>
            </div>
        </div>

        <!-- Module Fields -->
        <div class="field-group module-fields">
            <div class="group-title">Module Fields</div>
            <div class="group-content">
                <div class="field-item" @click="selectField('contact')" v-tippy="{ content: 'Kişi modülü ile ilişkilendirme için kullanılır. Mevcut kişilerden birini seçebilirsiniz.' }">
                    <i class="material-icons">person</i>
                    <span>{{ $t("modules.contact") }}</span>
                </div>
                <div class="field-item not-implemented" @click="selectField('ticket')" v-tippy="{ content: 'Destek talebi modülüyle ilişkilendirme için kullanılır. (Henüz kullanılabilir değil)' }">
                    <i class="material-icons">confirmation_number</i>
                    <span>{{ $t("message.ticket") }}</span>
                </div>
                <div class="field-item" @click="selectField('task')" v-tippy="{ content: 'Görev modülü ile ilişkilendirme için kullanılır. Mevcut görevlerden birini seçebilirsiniz.' }">
                    <i class="material-icons">assignment</i>
                    <span>{{ $t("message.task") }}</span>
                </div>
                <div class="field-item not-implemented" @click="selectField('event')" v-tippy="{ content: 'Etkinlik modülüyle ilişkilendirme için kullanılır. (Henüz kullanılabilir değil)' }">
                    <i class="material-icons">event</i>
                    <span>{{ $t("message.event") }}</span>
                </div>
                <div class="field-item" @click="selectField('user')" v-tippy="{ content: 'Kullanıcı modülü ile ilişkilendirme için kullanılır. Sistemdeki kullanıcılardan birini seçebilirsiniz.' }">
                    <i class="material-icons">support_agent</i>
                    <span>{{ $t("message.user") }}</span>
                </div>
                <div class="field-item" @click="selectField('conversation')" v-tippy="{ content: 'Sohbet/Görüşme modülü ile ilişkilendirme için kullanılır. Mevcut görüşmelerden birini seçebilirsiniz.' }">
                    <i class="material-icons">message</i>
                    <span>{{ $t("Chat") }}</span>
                </div>
            </div>
        </div>

        <!-- Record Metadata Fields -->
        <div class="field-group metadata-fields">
            <div class="group-title">Meta Fields</div>
            <div class="group-content">
                <div class="field-item" @click="selectField('record_id')" v-tippy="{ content: 'Kayıt benzersiz kimlik numarasını gösteren otomatik alan. Her kayıt için sistem tarafından atanır.' }">
                    <i class="material-icons">tag</i>
                    <span>Record ID</span>
                </div>
                <div class="field-item" @click="selectField('record_created_at')" v-tippy="{ content: 'Kaydın oluşturulma tarih ve saatini gösteren otomatik alan. Sistem tarafından atanır.' }">
                    <i class="material-icons">add_circle_outline</i>
                    <span>Record Created At</span>
                </div>
                <div class="field-item" @click="selectField('record_updated_at')" v-tippy="{ content: 'Kaydın son güncellenme tarih ve saatini gösteren otomatik alan. Her güncellemede sistem tarafından yenilenir.' }">
                    <i class="material-icons">update</i>
                    <span>Record Updated At</span>
                </div>
                <div class="field-item" @click="selectField('record_created_by')" v-tippy="{ content: 'Kaydı oluşturan kullanıcıyı gösteren otomatik alan. Sistem tarafından atanır.' }">
                    <i class="material-icons">person_add</i>
                    <span>Record Created By</span>
                </div>
                <div class="field-item" @click="selectField('record_updated_by')" v-tippy="{ content: 'Kaydı son güncelleyen kullanıcıyı gösteren otomatik alan. Her güncellemede sistem tarafından yenilenir.' }">
                    <i class="material-icons">person_outline</i>
                    <span>Record Updated By</span>
                </div>
            </div>
        </div>

        <!-- File Fields -->
        <div class="field-group file-fields">
            <div class="group-title">File Fields</div>
            <div class="group-content">
                <div class="field-item" @click="selectField('file')" v-tippy="{ content: 'Herhangi bir dosya türünü yüklemek ve saklamak için kullanılır. Belgeler, arşivler vb. için uygundur.' }">
                    <i class="material-icons">attachment</i>
                    <span>{{ $t("tables.file") }}</span>
                </div>
                <div class="field-item" @click="selectField('image')" v-tippy="{ content: 'Resim dosyalarını yüklemek ve görüntülemek için kullanılır. Resimler otomatik olarak küçük resim olarak gösterilir.' }">
                    <i class="material-icons">image</i>
                    <span>{{ $t("tables.image") }}</span>
                </div>
                <div class="field-item" @click="selectField('video')" v-tippy="{ content: 'Video dosyalarını yüklemek ve oynatmak için kullanılır. Desteklenen video formatları ile çalışır.' }">
                    <i class="material-icons">videocam</i>
                    <span>{{ $t("tables.video") }}</span>
                </div>
                <div class="field-item" @click="selectField('audio')" v-tippy="{ content: 'Ses dosyalarını yüklemek ve oynatmak için kullanılır. Desteklenen ses formatları ile çalışır.' }">
                    <i class="material-icons">audiotrack</i>
                    <span>{{ $t("tables.audio") }}</span>
                </div>
            </div>
        </div>

        <!-- Special Fields -->
        <div class="field-group special-fields">
            <div class="group-title">Special Fields</div>
            <div class="group-content">
                <div class="field-item" @click="selectField('ai')" v-tippy="{ content: 'Yapay zeka destekli alan. Metin analizi, özetleme, sınıflandırma gibi AI işlemleri için kullanılır.' }">
                    <i class="material-icons">auto_awesome</i>
                    <span>AI Field</span>
                </div>

                <div class="field-item" @click="selectField('formula')" v-tippy="{ content: 'Hesaplamalı alan. Diğer alanlardaki verileri kullanarak otomatik hesaplama yapar.' }">
                    <i class="material-icons">functions</i>
                    <span>Formula</span>
                </div>

                <div class="field-item" @click="selectField('lookup')" v-tippy="{ content: 'Başka bir tablodaki verileri görüntülemeye yarayan alan. İlişkili tablolardaki bilgileri gösterir.' }">
                    <i class="material-icons">sync_alt</i>
                    <span>Lookup</span>
                </div>

                <div class="field-item" @click="selectField('auto-increment')" v-tippy="{ content: 'Otomatik artan sayı/metin alanı. Her yeni kayıt için benzersiz ve sıralı bir değer üretir.' }">
                    <i class="material-icons">plus_one</i>
                    <span>Auto Increment</span>
                </div>

                <PermissionController :permissions="['automation.get', 'table.update']" controller="every">
                    <div class="field-item" @click="createAutomationButton">
                        <i class="material-icons">smart_button</i>
                        <span>{{ $t("tables.automationButton") }}</span>
                    </div>
                </PermissionController>

                <div class="field-item" @click="selectField('linked-record')" v-tippy="{ content: 'Başka bir tablo kaydına bağlantı kurmak için kullanılır. İlişkili kayıtları birbirine bağlar.' }">
                    <i class="material-icons">switch_access_shortcut</i>
                    <span>Linked Record</span>
                </div>
                <div class="field-item" @click="selectField('json')" v-tippy="{ content: 'JSON formatında veri saklamak için kullanılır. Karmaşık yapılandırılmış verileri depolamak için uygundur.' }">
                    <i class="material-icons">code</i>
                    <span>JSON</span>
                </div>
                <div class="field-item" @click="selectField('color')" v-tippy="{ content: 'Renk seçimi ve saklama için kullanılır. Renk paleti üzerinden seçim yapabilirsiniz.' }">
                    <i class="material-icons">palette</i>
                    <span>{{ $t("tables.color") }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "FieldSelector",
    methods: {
        selectField(fieldType) {
            if (["ticket"].includes(fieldType)) {
                this.$message.error("This feature is not available yet.");
                return;
            }
            this.$emit("field-selected", fieldType);
        },
        createAutomationButton() {
            this.$emit("close");
            this.$feature.beforeCreateButtonAutomation(() => {
                this.selectField("automation-button");
            });
        },
    },
});
</script>

<style scoped lang="scss">
.field-selector {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;

    .field-group {
        flex: 1;
        margin: 0;
        display: flex;
        flex-direction: column;
        border-right: 2px dashed #ccc;

        &:last-child {
            border-right: none;
        }

        .group-title {
            display: flex;
            align-items: center;
            background-color: #f0f0f5;
            padding: 8px;
            margin-bottom: 8px;
            font-weight: bold;
            border-radius: 4px;
            color: #333;
        }

        .group-content {
            display: flex;
            flex-direction: column;
            flex-grow: 1;

            .field-item {
                display: flex;
                align-items: center;
                padding: 6px;
                cursor: pointer;
                border-radius: 4px;
                margin-bottom: 4px;
                border-bottom: 1px solid #ddd;
                white-space: nowrap;
                min-width: 165px;

                &:hover {
                    background-color: #eef1f6;
                }

                i {
                    margin-right: 6px;
                }

                &.not-implemented {
                    display: none;
                }
            }
        }
    }

    /* Örnek renk uyumu: Gruplara farklı pastel tonlar ekleyebilirsiniz */
    .primitive-fields {
        background-color: #fafaff;
    }

    .validator-fields {
        background-color: #fffafa;
    }

    .module-fields {
        background-color: #fafffa;
    }

    .file-fields {
        background-color: #fefaf0;
    }

    .special-fields {
        background-color: #f9f0ff;
    }
    .metadata-fields {
        background-color: #f0faff;
    }
}
</style>
